import { Box, Grid, Tab, Typography, Button } from "@mui/material"
import { styled } from "@mui/material/styles"
import { TabContext } from "@mui/lab"

export const StyledContractDetails = {
    Wrapper: styled(Box)(({ theme }) => ({
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
    })),

    TabsWrapper: styled(Box)(({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(2),
    })),

    TabContext: styled(TabContext)(() => ({
        width: "100%",
        display: "flex",
        flexDirection: "column",
    })),

    BoxPanel: styled(Box)(() => ({
        padding: 0,
    })),

    Tab: styled(Tab)(({ theme }) => ({
        textTransform: "none",
        fontWeight: 600,
        padding: theme.spacing(1, 2),
        minHeight: 48,
    })),

    SectionTitle: styled(Typography)(({ theme }) => ({
        fontWeight: 600,
        fontSize: "1rem",
        marginBottom: theme.spacing(2),
        color: theme.palette.text.primary,
    })),

    SectionWrapper: styled(Box)(({ theme }) => ({
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.borderRadius,
    })),

    GridContainer: styled(Grid)(({ theme }) => ({
        marginBottom: theme.spacing(2),
    })),

    FieldLabel: styled(Typography)(({ theme }) => ({
        color: theme.palette.text.primary,
        fontSize: "1rem",
        fontWeight: 500,
        width: "40%",
    })),

    FieldValue: styled(Typography)(({ theme }) => ({
        color: theme.palette.text.secondary,
        fontSize: "0.875rem",
        wordBreak: "break-word",
    })),

    DetailRow: styled(Box)(() => ({
        display: "flex",
        flexDirection: "row",
    })),
    SimulateButton: styled(Button)(({ theme }) => ({
        textTransform: "uppercase",
        fontWeight: 500,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.75, 2),
        cursor: "pointer",
    })),

    NotFound: {
        Container: styled(Box)(() => ({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "500px",
            flexDirection: "column",
        })),

        Title: styled(Typography)(({ theme }) => ({
            color: theme.palette.error.main,
            marginBottom: theme.spacing(2),
            fontWeight: 500,
        })),

        Description: styled(Typography)(({ theme }) => ({
            color: theme.palette.text.secondary,
        })),
    },

    Tenant: {
        List: styled(Box)(({ theme }) => ({
            marginTop: theme.spacing(2),
            maxHeight: "calc(100vh - 100px)",
            minHeight: 200,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: 8,
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.grey[300],
                borderRadius: 4,
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: theme.palette.grey[100],
            },
        })),

        Card: styled(Box)(({ theme }) => ({
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2),
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            border: `1px solid ${theme.palette.divider}`,
        })),

        DetailRow: styled(Box)(({ theme }) => ({
            display: "flex",
            marginBottom: theme.spacing(1),
            "&:last-child": {
                marginBottom: 0,
            },
        })),

        DetailLabel: styled(Typography)(() => ({
            width: "40%",
            flexShrink: 0,
        })),

        DetailValue: styled(Typography)(({ theme }) => ({
            color: theme.palette.text.primary,
            fontSize: "0.875rem",
            fontWeight: 500,
            flex: 1,
        })),
    },

    BackCursor: styled("div")(() => ({
        cursor: "pointer",
    })),

    BreadcrumbContainer: styled("div")(() => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
    })),

    Header: {
        Wrapper: styled("div")(() => ({
            marginBottom: "32px",
        })),
    },
    ClickableCardItemContainer: styled(Box)(({ theme }) => ({
        cursor: "pointer",
        textDecoration: "underline",
        color: theme.palette.primary.main,
    })),
}
